import {
  Search, Share2, PhoneCall, Target, Palette, Globe, Tv, Radio, Signpost,
  Trophy, PenTool, Mail,
} from "lucide-react";

export const IMG = {
  heroOffice: "https://images.unsplash.com/photo-1603195827187-459ab02554a0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1500",
  meeting: "https://images.unsplash.com/photo-1603202662747-00e33e7d1468?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  billboard: "https://images.unsplash.com/photo-1760180139823-527522243bae?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  neon: "https://images.unsplash.com/photo-1763029642343-aed2718052a3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  social: "https://images.unsplash.com/photo-1764664035163-f8f29058e557?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  telemarketing: "https://images.unsplash.com/photo-1766066014237-00645c74e9c6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  team: "https://images.unsplash.com/photo-1603714228681-b399854b8f80?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  analytics: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  stadium: "https://images.unsplash.com/photo-1563299796-b729d0af54a5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/diensten", label: "Diensten" },
  { to: "/werkwijze", label: "Werkwijze" },
  { to: "/over-ons", label: "Over ons" },
  { to: "/contact", label: "Contact" },
];

// Full 360° marketing spectrum
export const SERVICES = [
  { slug: "digitale-marketing", icon: Search, title: "Digitale marketing", tag: "SEO & SEA", image: IMG.analytics,
    desc: "SEO, Google Ads en online advertising die jouw bedrijf bovenaan zetten en gericht verkeer binnenhalen." },
  { slug: "social-media", icon: Share2, title: "Social media", tag: "Advertising & beheer", image: IMG.social,
    desc: "Social advertising, community management en campagnes op Meta, TikTok, LinkedIn en meer." },
  { slug: "content-marketing", icon: PenTool, title: "Contentmarketing", tag: "Creatie", image: IMG.social,
    desc: "Video, fotografie, copywriting en storytelling die jouw merk laten spreken." },
  { slug: "telemarketing", icon: PhoneCall, title: "Telemarketing", tag: "B2C & B2B", image: IMG.telemarketing,
    desc: "Professionele telefonische campagnes: leadopvolging, afspraken maken en telefonische sales." },
  { slug: "leadgeneratie", icon: Target, title: "Leadgeneratie", tag: "Kwalitatieve leads", image: IMG.team,
    desc: "Wij werven en kwalificeren leads op maat, zodat jouw salesteam direct kan scoren." },
  { slug: "branding", icon: Palette, title: "Branding & creatie", tag: "Identiteit", image: IMG.meeting,
    desc: "Huisstijl, logo, design en campagneconcepten die een onvergetelijk merk bouwen." },
  { slug: "web-funnels", icon: Globe, title: "Websites & funnels", tag: "Bouw & conversie", image: IMG.analytics,
    desc: "Wij bouwen websites, landingspagina's en conversiefunnels die bezoekers omzetten in klanten." },
  { slug: "email-marketing", icon: Mail, title: "E-mailmarketing", tag: "Automation", image: IMG.analytics,
    desc: "E-mailcampagnes en marketing automation die leads opwarmen en klanten laten terugkomen." },
  { slug: "tv-marketing", icon: Tv, title: "TV-marketing", tag: "Broadcast", image: IMG.billboard,
    desc: "Van commercial tot media-inkoop — bereik massapubliek via televisie." },
  { slug: "radio-marketing", icon: Radio, title: "Radio-marketing", tag: "Audio", image: IMG.billboard,
    desc: "Radiocommercials en audiocampagnes die blijven hangen bij jouw doelgroep." },
  { slug: "billboard-ooh", icon: Signpost, title: "Billboard & OOH", tag: "Out-of-home", image: IMG.neon,
    desc: "Billboards, abri's en buitenreclame die jouw merk groot en zichtbaar maken in de stad." },
  { slug: "sport-clubs", icon: Trophy, title: "Sport & clubs", tag: "Sponsoring", image: IMG.stadium,
    desc: "Sportsponsoring en clubmarketing die jouw merk verbinden aan passie en community." },
];

export const PROCESS = [
  { n: "01", title: "Audit & strategie", text: "Wij analyseren jouw merk, markt en doelen en bepalen het juiste kanaalplan." },
  { n: "02", title: "Multichannel setup", text: "Creatie, campagnes, funnels en systemen worden ingericht over alle gekozen kanalen." },
  { n: "03", title: "Executie & launch", text: "Wij lanceren de campagnes en zetten onze teams in — van online tot telefonisch." },
  { n: "04", title: "Schaal & ROI", text: "Wij meten, optimaliseren en schalen op wat werkt voor maximaal rendement." },
];

export const STATS = [
  { value: "360°", label: "Marketingspectrum" },
  { value: "12+", label: "Marketingdisciplines" },
  { value: "1", label: "Partner voor alles" },
  { value: "100%", label: "In eigen beheer" },
];

export const WHY = [
  { title: "Eén partner, alle kanalen", text: "Van SEO tot billboard en telemarketing — alles onder één dak, perfect op elkaar afgestemd." },
  { title: "Online én offline", text: "Wij combineren digitale marketing met TV, radio en buitenreclame voor maximaal bereik." },
  { title: "Eigen executieteams", text: "Creatie, campagnes en telemarketing voeren wij zelf uit. Geen losse bureaus, één aanspreekpunt." },
  { title: "Resultaatgericht", text: "Wij sturen op leads, conversie en ROI — niet op vage vanity-cijfers." },
];

export const TRUST_ITEMS = [
  "Digitale marketing", "Telemarketing", "Social media", "TV & Radio", "Billboard & OOH",
  "Leadgeneratie", "Branding & creatie", "Websites & funnels", "Sportsponsoring", "Contentmarketing",
];

// Offerte flow options
export const QUOTE_SERVICES = SERVICES.map((s) => s.title);
export const BUDGET_OPTIONS = ["< €2.500 / maand", "€2.500 – €5.000 / maand", "€5.000 – €10.000 / maand", "€10.000+ / maand", "Nog niet bepaald"];
export const TIMELINE_OPTIONS = ["Zo snel mogelijk", "Binnen 1 maand", "Binnen 3 maanden", "Oriënterend"];

export const WHATSAPP_NUMBER = "31621855528";
export const WHATSAPP_DISPLAY = "+31 6 21855528";
export const EMAIL = "info@imperiumgroup.nl";
